export const VIEW_MEMBERSHIP = 'membership';
export const VIEW_REGION_DETAILS = 'regionDetails';

/**
 * Sheet navigation: membership list vs region-details subview.
 * Keeps BlockEditorSheet as chrome + router only.
 */
export function createInitialSheetNav(initialView = VIEW_MEMBERSHIP, focusRegion = null) {
    return {
        view: initialView === VIEW_REGION_DETAILS ? VIEW_REGION_DETAILS : VIEW_MEMBERSHIP,
        focusRegion: initialView === VIEW_REGION_DETAILS ? (focusRegion || null) : null,
    };
}

export function blockSheetNavReducer(state, action) {
    switch (action?.type) {
        case 'reset':
            return createInitialSheetNav(action.view, action.focusRegion);
        case 'showMembership':
            return { view: VIEW_MEMBERSHIP, focusRegion: null };
        case 'showRegionDetails':
            return { view: VIEW_REGION_DETAILS, focusRegion: action.region || null };
        default:
            return state;
    }
}
